const imageSource = /^data:image\/(png|jpeg|webp|gif);base64,[a-z0-9+/=\s]+$/i;

const exportBoard = function(name, notes) {
  return JSON.stringify({
    format: 'stickii',
    version: 1,
    boards: [{
      name,
      notes
    }]
  }, null, 2);
};

const parseBoards = function(text) {
  let data;

  try {
    data = JSON.parse(text);
  } catch {
    throw new Error('this file is not valid json.');
  }

  if (data?.format !== 'stickii' || data.version !== 1 || !Array.isArray(data.boards) || !data.boards.length) {
    throw new Error('choose a stickii board export file.');
  }

  return data.boards.map(board => {
    if (typeof board.name !== 'string' || !Array.isArray(board.notes)) throw new Error('the board file is incomplete.');

    const notes = board.notes.map(note => {
      if (!note || !['x', 'y', 'width', 'height'].every(key => Number.isFinite(note[key])) || note.width <= 0 || note.height <= 0 || !Array.isArray(note.images) || typeof note.text !== 'string') {
        throw new Error('the board contains an invalid item.');
      }

      if (note.kind && !['note', 'image'].includes(note.kind)) throw new Error('the board contains an unknown item type.');

      // Reassign imported IDs so copies remain independent of their source board.
      const images = note.images.map(image => {
        if (!image || typeof image.src !== 'string' || !imageSource.test(image.src)) throw new Error('the board contains an invalid image.');

        return {
          id: crypto.randomUUID(),
          src: image.src,
          name: typeof image.name === 'string' ? image.name : 'imported image'
        };
      });

      if (note.kind === 'image' && !images.length) throw new Error('an image item is missing its image.');

      return {
        id: crypto.randomUUID(),
        kind: note.kind || 'note',
        x: note.x,
        y: note.y,
        width: note.width,
        height: note.height,
        color: typeof note.color === 'string' ? note.color : 'butter',
        title: typeof note.title === 'string' ? note.title : '',
        text: note.text,
        minimized: note.minimized === true,
        images,
        layer: Number.isFinite(note.layer) ? note.layer : 0,
        ...(note.kind === 'image' ? {
          aspectRatio: note.width / note.height
        } : {})
      };
    });

    return {
      name: board.name.trim() || 'imported board',
      notes
    };
  });
};

export { exportBoard, parseBoards };
